// @flow

import * as React from 'react';
import Slider, { Handle } from 'rc-slider';

import Tooltip from 'rc-tooltip';

const handle = (props: any) => {
  const { value, dragging, index, className, ...restProps } = props;
  return (
    <Tooltip prefixCls="rc-slider-tooltip" overlay={value} visible={dragging} placement="top" key={index}>
      <Handle value={value} {...restProps} className={dragging ? className + ' dragging' : className} />
    </Tooltip>
  );
};

const withTooltip = (Component: React.ComponentType<*>) => {
  const WithToolTips = (props: *) => <Component {...props} handle={handle} />;
  return WithToolTips;
};

const TooltipSlider = withTooltip(Slider);

export class StockSlider extends React.PureComponent<{ value: number }> {
  render() {
    return (
      <div className="price-slider stock">
        <TooltipSlider
          {...this.props}
          marks={{
            [this.props.value]: this.props.value,
          }}
        />
      </div>
    );
  }
}
